module.exports = __webpack_public_path__ + "static/media/icon-project-type.b739fa22.svg";